import type { ProductOrigin, Material } from '@igus/iglidur-free-form-hub-interfaces';
import { useTranslation } from 'next-i18next';
import { Procedures, allProductsOrigins } from '@igus/iglidur-free-form-hub-interfaces';
import { getProcedureText } from '@hub/free-form-hub/common/utils';

type MaterialTeaserProps = {
  material: Material;
  origin?: ProductOrigin;
};
export const MaterialTeaser = ({ material, origin }: MaterialTeaserProps) => {
  const { t } = useTranslation(['category/productFilter', 'common']);

  return (
    <div>
      <p className="font-bold">{t(`MATERIALS.${material.name}_NAME`, { ns: 'free-form-hub/materials' })}</p>
      <p className="font-light">
        {material.procedure === Procedures.IM && origin === allProductsOrigins[0] && (
          <>
            <span>{t('COMMON.PRODUCTION_METHODS.PROTOTYPE_SERVICE', { ns: 'free-form-hub/freeFormHubCommon' })}</span>
            <br />
          </>
        )}
        <span>{getProcedureText(material.procedure, t)}</span>
      </p>
    </div>
  );
};
